import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { Grid, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import { ImcGenericStyle } from './ImcGenericStyle';
import Chart from './Chart';
import { getInfoBascula, getPorcentageByidBascula } from '../../domain/api/AlcoholimetriaApi';
import ChartIgc from './ChartIgc';
import ChartPa from './ChartPa';
import { DATE_INIT, DATE_END } from '../../../app/api-client/constants';
import '../GeneriBascula.js/graficas.css'
import BasicDateRangePicker from './BasicDateRangePicker';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import { GenericBascula } from '../GeneriBascula.js';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { useDispatch } from 'react-redux';
import ChartOximetria from './ChartOxigeno';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export const ImcGeneric = (props) => {

    const classes = ImcGenericStyle();
    const fixedHeightFilter = clsx(classes.paper, classes.fixedHeightFilter);
    const fixedHeightTarg = clsx(classes.paper, classes.fixedHeightTarg);
    let { id } = useParams();
    const location = useLocation()
    const { nameBascula } = location.state === undefined ? "-" : location.state
    const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery('(max-width:1000px)');

    const [dataPorcentage, setdataPorcentage] = useState("-");
    const [dataTotal, setdataTotal] = useState("-");
    const [datatotal_users, setdataTotal_users] = useState("-");

    let generoInicial = {
        femenino: "-",
        masculino: "-",
        nr: "-",
        total: "-",
        name: "-"
    }
    const [infoBascula, setInfoBascula] = useState({ maxUser: 0, genero: generoInicial, genericIESs: [] });


    const [, setImcGrafic] = useState([]);
    const [imcTotalGrafic, setImcTotalGrafic] = useState([]);
    const [imcValorTotalGrafic, setValorTotalGrafic] = useState([]);
    const [igcGrafic, setIgcGrafic] = useState([]);
    const [igcTotal, setIgcTotal] = useState([]);
    const [igcValorTotal, setIgcValorTotal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [dataStart, setDataStart] = useState("");
    const [dataEnd, setDataEnd] = useState("");
    const [dataBascula, setDataBascula] = useState([])
    const [femenino, setFemenino] = useState("")
    const [masculino, setMasculino] = useState("")
    const [sinregistrar, setSinRegistro] = useState("")


    // PA chart
    const [paGrafic, setPaGrafic] = useState([]);
    // PA pie
    const [paiGraficPa, setPaiGraficPa] = useState([])
    const [paiValorTotalGraficPa, setValorTotalGraficPa] = useState([])

    // Oximetria chart
    const [dataOximetria, setdataOximetria] = useState([])
    // Oximetria Pie
    const [dataPieOximetria, setdataPieOximetria] = useState([])
    const [dataVrTotallPieOximetria, setVrTotaldataPieOximetria] = useState([])

    // Setear fechas a filtros
    const handlerFilter = (dataStart, dateEnd) => {
        setDataEnd(UtilsDate().formatYYYYMMdd(dateEnd));
        setDataStart(UtilsDate().formatYYYYMMdd(dataStart))
    };


    // Oreganizar y setear datos de IMC
    const dataOrganizationIMC = (IMC) => {

        let dataPieIMC = []
        let contBajoIMC = IMC[0].totalUsuariosModulo;
        let contNormalIMC = IMC[1].totalUsuariosModulo;
        let contSobrePesoIMC = IMC[2].totalUsuariosModulo;
        let contObsesidadIMC = IMC[3].totalUsuariosModulo;
        let contObsesidad2IMC = IMC[4].totalUsuariosModulo;
        let contObsesidad3IMC = IMC[5].totalUsuariosModulo;
        let contNoREgistraIMC = IMC[6] && IMC[6].totalUsuariosModulo !== undefined && IMC[6].totalUsuariosModulo !== null
            ? IMC[6].totalUsuariosModulo
            : 0;

        dataPieIMC.push(
            {
                name: "Bajo",
                value1: contBajoIMC
            },
            {
                name: "Normal",
                value2: contNormalIMC
            },
            {
                name: "SobrePeso",
                value3: contSobrePesoIMC
            },
            {
                name: "Obesidad",
                value4: contObsesidadIMC
            },
            {
                name: "Obesidad2",
                value5: contObsesidad2IMC
            },
            {
                name: "Obesidad3",
                value6: contObsesidad3IMC
            },
            {
                name: "Sin registro",
                value7: contNoREgistraIMC
            }
        )

        setImcTotalGrafic(dataPieIMC)

    }

    // Oreganizar y setear datos de PA
    const dataOrganizationPa = (PA) => {

        let dataPiePa = []
        let contMuyAltoPa = PA[4].totalUsuariosModulo;;
        let contAltoPa = PA[3].totalUsuariosModulo;;
        let contNormalPa = PA[2].totalUsuariosModulo;;

        let contBajoPa = PA[0].totalUsuariosModulo;;
        let contOptima = PA[1].totalUsuariosModulo;;
        let contNoregistra = PA[5] && PA[5].totalUsuariosModulo !== undefined && PA[5].totalUsuariosModulo !== null
            ? PA[5].totalUsuariosModulo
            : 0;

        dataPiePa.push(
            {
                name: "Hipotension",
                value1: contBajoPa
            },
            {
                name: "Optima",
                value2: contOptima
            },
            {
                name: "Normal",
                value3: contNormalPa
            },
            {
                name: "Sospecha",
                value4: contAltoPa
            },
            {
                name: "Hipertension",
                value5: contMuyAltoPa
            },
            {
                name: "Sin registro",
                value6: contNoregistra
            }
        )

        setPaiGraficPa(dataPiePa)
    }

    // Organizar y setear datos de IGC
    const dataOrganizationIGC = (IGC) => {

        let dataPieIGC = []
        let contBajoIGC = IGC[0].totalUsuariosModulo;
        let contNormalIGC = IGC[1].totalUsuariosModulo;
        let contSobrePesoIGC = IGC[2].totalUsuariosModulo;
        let contObesidadIGC = IGC[3].totalUsuariosModulo;
        let contNoRegistraIGC = IGC[4] && IGC[4].totalUsuariosModulo !== undefined && IGC[4].totalUsuariosModulo !== null
            ? IGC[4].totalUsuariosModulo
            : 0;

        dataPieIGC.push(
            {
                name: "Bajo",
                value1: contBajoIGC
            },
            {
                name: "Normal",
                value2: contNormalIGC
            },
            {
                name: "Alta",
                value3: contSobrePesoIGC
            },
            {
                name: "Muy Alta",
                value4: contObesidadIGC
            },
            {
                name: "Sin registro",
                value5: contNoRegistraIGC
            }
        )

        setIgcTotal(dataPieIGC)
    }

    // Oreganizar y setear datos de OXIMETRIA
    const dataOrganizationOX = (OX) => {

        let dataPieOX = []
        let contNormalOX = OX[0].totalUsuariosModulo;
        let contHipoxLeveOX = OX[1].totalUsuariosModulo;
        let contHipoxModeOX = OX[2].totalUsuariosModulo;
        let contNoRegistraOX = OX[3] && OX[3].totalUsuariosModulo !== undefined && OX[3].totalUsuariosModulo !== null
            ? OX[3].totalUsuariosModulo
            : 0;


        dataPieOX.push(
            {
                name: "Normal",
                value1: contNormalOX
            },
            {
                name: "Hipoxia Leve",
                value2: contHipoxLeveOX
            },
            {
                name: "Hipoxia Moderada",
                value3: contHipoxModeOX
            },
            {
                name: "Sin registro",
                value4: contNoRegistraOX
            }
        )

        setdataPieOximetria(dataPieOX)
    }



    useEffect(async () => {

        setIsLoading(true);
        localStorage.setItem(DATE_INIT, dataStart);
        localStorage.setItem(DATE_END, dataEnd);

        if (dataStart !== "" && dataEnd !== "") {

            {/** DATOS - TARJETA INFORMACION GENERAL*/ }
            const responseInfoGeneric = await getPorcentageByidBascula(dispatch, idBascula, dataStart, dataEnd)
            setValorTotalGrafic(responseInfoGeneric?.respuesta?.totalUserModulo?.totalModulos[0]?.total || "-");
            setValorTotalGraficPa(responseInfoGeneric?.respuesta?.totalUserModulo?.totalModulos[2]?.total || "-");
            setIgcValorTotal(responseInfoGeneric?.respuesta?.totalUserModulo?.totalModulos[1]?.total || "-");
            setVrTotaldataPieOximetria(responseInfoGeneric?.respuesta?.totalUserModulo?.totalModulos[3]?.total || "-");

            const porcentaje = (responseInfoGeneric ? responseInfoGeneric.codigoRespuesta === "0000" ? responseInfoGeneric.respuesta?.porcentajeUso == null ? "-" : responseInfoGeneric.respuesta?.porcentajeUso : responseInfoGeneric.respuesta?.porcentajeUso : 0)

            const total = (responseInfoGeneric ? responseInfoGeneric.codigoRespuesta === "0000" ? responseInfoGeneric.respuesta?.totalUserEvbi == null ? 0 : responseInfoGeneric.respuesta?.totalUserEvbi : responseInfoGeneric.respuesta?.totalUserEvbi : 0)
            const total_users = (responseInfoGeneric ? responseInfoGeneric.codigoRespuesta === "0000" ? responseInfoGeneric.respuesta?.totalUserRegister == null ? 0 : responseInfoGeneric.respuesta?.totalUserRegister : responseInfoGeneric.respuesta?.totalUserRegister : 0)
            // const theData = (responseInfoGeneric.codigoRespuesta)


            //Poblacion e IES
            const infoBascula = await getInfoBascula(dispatch, idBascula, dataStart, dataEnd);

            setFemenino(responseInfoGeneric.respuesta.totalGenero?.femenino === undefined ? "-" : responseInfoGeneric.respuesta.totalGenero.femenino);
            setMasculino(responseInfoGeneric.respuesta.totalGenero?.masculino === undefined ? "-" : responseInfoGeneric.respuesta.totalGenero.masculino);
            setSinRegistro(responseInfoGeneric.respuesta.totalGenero?.sr === undefined ? "-" : responseInfoGeneric.respuesta.totalGenero.sr);

            {/** DATOS - TARJETA IMC*/ }
            const imcGrafic = (responseInfoGeneric.respuesta.totalUserModulo?.totalModulos[0].totalModulos === undefined ? "-" : responseInfoGeneric.respuesta.totalUserModulo.totalModulos[0].totalModulos);



            {/** DATOS - TARJETA OXIMETRIA*/ }
            const oximetria = (responseInfoGeneric.respuesta.totalUserModulo?.totalModulos[3].totalModulos === undefined ? "-" : responseInfoGeneric.respuesta.totalUserModulo.totalModulos[3].totalModulos);
            //datos tarjeta igrasa corporal
            const igcGrafic = (responseInfoGeneric.respuesta.totalUserModulo?.totalModulos[1].totalModulos === undefined ? "-" : responseInfoGeneric.respuesta.totalUserModulo.totalModulos[1].totalModulos);

            //datos tarjeta presion arterial
            const paGrafic = (responseInfoGeneric.respuesta.totalUserModulo?.totalModulos[2].totalModulos === undefined ? "-" : responseInfoGeneric.respuesta.totalUserModulo.totalModulos[2].totalModulos);
            setIsLoading(false);

            // Capturar errores en las llamadas al api
            try {

                setInfoBascula(infoBascula.genericIESs);

                {/** DATOS SETEADOS - TARJETA PORCENTAJE*/ }
                setdataPorcentage(porcentaje.toString().substring(0, 3))
                setdataTotal(total)
                setdataTotal_users(total_users)

                {/** DATOS - TARJETA IMC */ }
                setImcGrafic(imcGrafic)
                const imcmodulo = responseInfoGeneric.respuesta.totalUserModulo.totalModulos.find(modulo => modulo.modulo === 'imc');

                if (imcmodulo) {
                    dataOrganizationIMC(imcmodulo.totalModulos);

                }


                {/** DATOS - TARJETA PA*/ }
                setPaGrafic(paGrafic)
                const pamodulo = responseInfoGeneric.respuesta.totalUserModulo.totalModulos.find(modulo => modulo.modulo === 'presion');

                if (pamodulo) {
                    dataOrganizationPa(pamodulo.totalModulos);

                }

                {/** DATOS - TARJETA IGC*/ }
                setIgcGrafic(igcGrafic)
                const IGCModulo = responseInfoGeneric.respuesta.totalUserModulo.totalModulos.find(modulo => modulo.modulo === 'pgc');

                if (IGCModulo) {
                    dataOrganizationIGC(IGCModulo.totalModulos);

                }


                {/** DATOS - TARJETA OXIMETRIA*/ }
                setdataOximetria(oximetria)
                const oximetriaModulo = responseInfoGeneric.respuesta.totalUserModulo.totalModulos.find(modulo => modulo.modulo === 'oximetria');

                if (oximetriaModulo) {
                    dataOrganizationOX(oximetriaModulo.totalModulos);

                }

            } catch (err) {
                console.log("este es el error", err)

            }

        }



    }, [dataStart, dataEnd]);


    return (
        <>

            <Grid item xs={12} >
                <br></br>
                <br></br>

                <MigaPan
                    namePage={`Detalle ${nameBascula}`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas/"
                >
                    Home
                </MigaPan>
            </Grid>


            <Grid style={{ overflowY: 'auto', height: '100vh', overflowX: 'hidden' }}>
                <style>
                    {`
      ::-webkit-scrollbar {
        width: 12px;
        border-radius: 10px;
        height: 15px;
      }

      ::-webkit-scrollbar-thumb {
        background: #E1E1E1;
        border-radius: 10px;
        height: 20px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #E1E1E1;
      }
    `}
                </style>
                <Paper className={isSmallScreen ? classes.fullWidthPaper : classes.container}> {/* Agregamos un Paper para envolver todo */}
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Paper className={fixedHeightFilter}>
                                <BasicDateRangePicker
                                    handlerFilter={handlerFilter}
                                    // isLoading={isLoading}
                                    isDate={false}
                                    titlePanel={`Estación ${nameBascula == 'Alqueria' ? 'Alquería' : nameBascula}`}
                                />
                            </Paper>
                        </Grid>

                        <GenericBascula
                            femenino={femenino}
                            masculino={masculino}
                            sinregistrar={sinregistrar}
                            infoBascula={infoBascula}
                            dataBascula={dataBascula}
                            idBascula={idBascula}
                            titlePanel={nameBascula}
                            porcentage={dataPorcentage}
                            total={dataTotal}
                            total_users={datatotal_users}
                            fechaIni={dataStart}
                            fechaFin={dataEnd}

                        />
                        <Grid item xs={12} md={6}>
                            <Paper className={fixedHeightTarg}>
                                <Chart
                                    dataD={imcTotalGrafic}
                                    valorTotal={imcValorTotalGrafic}
                                    fechaIni={dataStart}
                                    fechaFin={dataEnd}
                                />
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper className={fixedHeightTarg}>
                                <ChartPa
                                    data={paGrafic}
                                    dataD={paiGraficPa}
                                    valorTotal={paiValorTotalGraficPa}
                                    fechaIni={dataStart}
                                    fechaFin={dataEnd}
                                />
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper className={fixedHeightTarg}>
                                <ChartIgc
                                    data={igcGrafic}
                                    dataD={igcTotal}
                                    valorTotal={igcValorTotal}
                                    fechaIni={dataStart}
                                    fechaFin={dataEnd}
                                />
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper className={fixedHeightTarg}>
                                <ChartOximetria
                                    data={dataOximetria}
                                    dataD={dataPieOximetria}
                                    valorTotal={dataVrTotallPieOximetria}
                                    fechaIni={dataStart}
                                    fechaFin={dataEnd}
                                />
                            </Paper>
                        </Grid>

                    </Grid>
                </Paper>
            </Grid>
        </>
    );
}
